export const deletedOptions = [
  { label: 'Показывать', value: 'true' },
  { label: 'Не показывать', value: 'false' },
];
